export type ProviderPriceListModel = {
  active_product_ids?: number[],
  assigned_service_product_ids?: [],
  cache_key: number,
  dates: {
    expiry: {
      date: string,
    },
  },
  default: boolean,
  expires_at: string,
  hidden: boolean,
  id: number,
  is_master: boolean,
  master_price_list_id: number,
  master_price_list_version: string,
  next_price_list_id: number,
  provider_id: number,
  public_token: string,
  service_id: number,
  soft_match_codes: boolean,
  title: string,
}

export type ProviderPriceListRequestOptions = {
  include_provider_price_list_provider?: boolean,
}

const state = {
  default: false,
  expires_at: '',
  hidden: false,
  id: null,
  is_master: false,
  master_price_list_id: undefined,
  master_price_list_version: undefined,
  next_price_list_id: undefined,
  provider_id: undefined,
  public_token: undefined,
  service_id: undefined,
  soft_match_codes: false,
  title: '',
}

export const requiredFields = [
  { key: 'provider_id' },
  { key: 'service_id' },
  { key: 'title' },
]

export default state
